export interface PageExportModalState {
    onExport: () => void | Promise<void>;
    loading: boolean | Ref<boolean> | ComputedRef<boolean>;
    tooltip?: string;
}

const exportStates = ref<Map<string, PageExportModalState>>(new Map<string, PageExportModalState>());

export function usePageExportModal(windowId?: string) {
    return computed(() => {
        if (windowId) {
            return exportStates.value.get(windowId) || null;
        }
        return null;
    });
}

export function registerPageExportModal(state: PageExportModalState, windowId: string) {
    const newMap = new Map<string, PageExportModalState>(exportStates.value);
    newMap.set(windowId, state);
    exportStates.value = newMap;
}

export function unregisterPageExportModal(windowId: string) {
    const newMap = new Map<string, PageExportModalState>(exportStates.value);
    newMap.delete(windowId);
    exportStates.value = newMap;
}
